import React, { useEffect } from "react";
import { ContentContainer } from "../../../../components/layout";
import {
  Button,
  Checkbox,
  Select,
  Textarea,
  Textfield,
  Tooltip,
} from "../../../../components/core";
import { Divider } from "primereact/divider";
import { Strings } from "../../../../constants/strings";
import { useParams } from "react-router-dom";
import RadioButtonV2 from "../../../../components/core/checkbox-v2";

const BranchProfileForm = ({
  isEditing = false,
  partnerTypesItems,
  partnerCategoryItems,
  branchProfileData,
  partnerCategory,
  contactPersonFields,
  handleOnChange,
  changesMade,
  onSubmit,
  handleSaveChanges,
  // handleValidateFields,
  handleCancelChanges,
  onCancel,
  setValidation,
  headOfficeExists = false,
  amIHeadOffice = false,
  headOfficeName = "",
  ...props
}) => {
  const { partnerBranchId } = useParams();

  // useEffect(() => {
  if (partnerBranchId !== null && partnerBranchId !== undefined) {
    isEditing = true;
  } else {
    isEditing = false;
  }

  console.log({ amIHeadOffice });
  // }, []);
  const containerTitle = `${
    isEditing
      ? `EDIT BRANCH ${headOfficeName !== "" ? "(HEAD OFFICE)" : ""}`
      : "ADD BRANCH"
  }`;
  const submitButtonText = "Save Changes";
  const cancelButtonText = "Cancel";

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit();
    } else {
      handleValidateFields();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_confirm_cancel_title,
        message: Strings.popup_confirm_cancel_massage,
        open: true,
        actions: (
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"No"}
              className={"p-2 w-full"}
            />
            <Button
              onClick={handleCancelChanges}
              value={"Yes"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    }
  };

  console.log({ branchProfileData, isEditing });

  const showValidationError = (message) => {
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
      title: Strings.popup_error_title,
      message,
      open: true,
      actions: (
        <div className="grid grid-cols-1 gap-2">
          <Button
            value={"OK"}
            className={"p-2"}
            onClick={() => setValidation(false)}
          />
        </div>
      ),
    });
  };

  const handleValidateFields = () => {
    const updatedData = { ...branchProfileData };
    let emailRegex = /^[a-zA-Z0-9._%+-ñÑ]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Simple validation checks with early returns
    if (updatedData.partnerCategoryNo === "-1")
      return showValidationError("Partner Category is a required field");

    if (updatedData.partnerId === "-1")
      return showValidationError("Partner is a required field");

    if (updatedData.partnerBranch === "")
      return showValidationError("Partner Branch is a required field");

    if (updatedData.contactPerson === "" || updatedData.contactPerson2 === "")
      return showValidationError("Contact Name is a required field");

    if (
      updatedData.contactPosition === "" ||
      updatedData.contactPosition === ""
    )
      return showValidationError("Contact Position is a required field");

    if (updatedData.mobile !== "" || updatedData.mobile2 !== "") {
      if (updatedData.mobile.length < 10 || updatedData.mobile2.length < 10) {
        return showValidationError("Please enter a valid mobile number");
      }
      if (
        !updatedData.mobile.startsWith("9") ||
        !updatedData.mobile2.startsWith("9")
      ) {
        return showValidationError("Invalid mobile number format");
      }
    } else {
      return showValidationError("Contact Mobile is a required field");
    }

    if (updatedData.email === "" || updatedData.email2 === "")
      return showValidationError("Contact Email is a required field");

    if (
      (updatedData.email !== "" && !emailRegex.test(updatedData.email)) ||
      (updatedData.email2 !== "" && !emailRegex.test(updatedData.email2))
    )
      return showValidationError("Please provide a valid email address");

    if (updatedData.landline === "" || updatedData.landline2 === "")
      return showValidationError("Contact Landline is a required field");

    // Then validate length
    if (updatedData.landline.length < 10 || updatedData.landline.length > 11)
      return showValidationError("Landline must be 10-11 characters");
    if (updatedData.landline2.length < 10 || updatedData.landline2.length > 11)
      return showValidationError("Landline must be 10-11 characters");
    
    else {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        title: Strings.popup_confirm_save_title,
        message: Strings.popup_confirm_save_massage,
        open: true,
        actions: (
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"No"}
              className={"p-2 w-full"}
            />
            <Button
              onClick={handleSaveChanges}
              value={"Yes"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    }
  };

  return (
    <ContentContainer containerTitle={containerTitle} {...props}>
      <div className="grid grid-cols-8">
        <div className="col-span-8">
          <div className="grid grid-cols-12 items-center space-y-2">
            {/* {isEditing && ( */}

            {/* Partner Category */}
            {!isEditing && (
              <>
                <div className="col-span-2">
                  <i className="text-red-500 mr-2">*</i>Partner Category:
                </div>

                <div className="col-span-6">
                  <Select
                    items={partnerCategoryItems}
                    defaultOption={{
                      value: "-1",
                      name: "-- Select Partner Category --",
                    }}
                    name="partnerCategoryNo"
                    value={branchProfileData.partnerCategoryNo}
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-span-4"></div>
              </>
            )}

            {/* Partner  */}
            <div className="col-span-2">
              <i className="text-red-500 mr-2">*</i>Partner:
            </div>
            <div className="col-span-6">
              <Select
                items={partnerTypesItems}
                defaultOption={{
                  value: "-1",
                  name: "-- Select Partner --",
                }}
                name="partnerId"
                disabled={
                  isEditing || branchProfileData.partnerCategoryNo === "-1"
                }
                value={branchProfileData.partnerId}
                onChange={handleOnChange}
              />
            </div>
            <div className="col-span-4"></div>

            {/* head office assignment */}
            <div className="col-span-2">
              <i className="text-red-500 mr-2">*</i>Branch Level:
            </div>
            <div className="col-span-6 flex items-center space-x-2">
              <RadioButtonV2
                disabled={
                  // Disable if:
                  // 1. No partner selected, OR
                  // 2. Head office exists AND current branch is NOT the head office
                  branchProfileData.partnerId === "" ||
                  (headOfficeExists && !amIHeadOffice)
                  // &&
                  // branchProfileData.branchLevel !== 0
                }
                value={branchProfileData.branchLevel}
                label="Head office"
                onChange={handleOnChange}
                checked={branchProfileData.branchLevel === 0}
                type="checkbox"
                name="branchLevel"
              />
              {headOfficeExists && !amIHeadOffice && (
                <Tooltip
                  withMargin={false}
                  message={`A head office already exists for this partner. To assign a new head office, please uncheck the Head Office checkbox of branch ${headOfficeName}`}
                />
              )}
            </div>
            <div className="col-span-4"></div>

            {/* Branch Name */}
            <div className="col-span-2">
              <i className="text-red-500 mr-2">*</i>Branch Name:
            </div>
            <div className="col-span-6">
              <Textfield
                maxLength={86}
                placeholder="Enter branch name"
                name="partnerBranch"
                value={branchProfileData.partnerBranch}
                onChange={handleOnChange}
              />
            </div>
            <div className="col-span-4"></div>
          </div>
        </div>

        {/* Divider */}
        <div className="col-span-8 px-4">
          <Divider className="border border-gray-200" />
        </div>

        {/* contact person */}
        <div className="col-span-8">
          <div className="mb-4">
            <h2 className="text-[17px] font-bold">Contact Persons</h2>
          </div>

          {contactPersonFields.map((contactPerson) => (
            <div
              key={contactPerson.index}
              className="border border-gray-300 rounded-lg p-4 mb-4 bg-gray-50"
            >
              <div className="mb-3">
                <div className="font-semibold">
                  Contact Person {contactPerson.index}
                </div>
              </div>

              <div className="grid grid-cols-12 space-y-2 items-center">
                {/* Contact Name */}
                <div className="col-span-2">
                  <i className="text-red-500 mr-2">*</i>Contact Name:
                </div>
                <div className="col-span-6">
                  <Textfield
                    maxLength={86}
                    placeholder="Enter contact name"
                    name={contactPerson.fields.contactPerson}
                    value={
                      branchProfileData[contactPerson.fields.contactPerson]
                    }
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-span-4"></div>

                {/* Contact Position */}
                <div className="col-span-2">
                  <i className="text-red-500 mr-2">*</i>Contact Position:
                </div>
                <div className="col-span-6">
                  <Textfield
                    placeholder="Enter contact position"
                    maxLength={86}
                    name={contactPerson.fields.contactPosition}
                    value={
                      branchProfileData[contactPerson.fields.contactPosition]
                    }
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-span-4"></div>

                {/* Mobile Number */}
                <div className="col-span-2">
                  <i className="text-red-500 mr-2">*</i>Mobile Number:
                </div>
                <div className="col-span-1 text-center font-medium">+63</div>
                <div className="col-span-5">
                  <Textfield
                    isNumberOnly={true}
                    maxLength={10}
                    placeholder="Enter mobile number"
                    name={contactPerson.fields.mobile}
                    value={branchProfileData[contactPerson.fields.mobile]}
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-span-4"></div>

                {/* Email */}
                <div className="col-span-2">
                  <i className="text-red-500 mr-2">*</i>Email:
                </div>
                <div className="col-span-6">
                  <Textfield
                    placeholder="Enter email address"
                    type="email"
                    name={contactPerson.fields.email}
                    value={branchProfileData[contactPerson.fields.email]}
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-span-4"></div>

                {/* Landline */}
                <div className="col-span-2">
                  <i className="text-red-500 mr-2">*</i>Landline:
                </div>
                <div className="col-span-6">
                  <Textfield
                    maxLength={11}
                    placeholder="Enter landline number"
                    name={contactPerson.fields.landline}
                    value={branchProfileData[contactPerson.fields.landline]}
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-span-4"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="col-span-8 px-4">
          <Divider className="border border-gray-200" />
        </div>

        {/* Remarks Section */}
        <div className="col-span-8">
          <div className="grid grid-cols-12 items-center space-y-2">
            <div className="col-span-2">
              {/* <i className="text-red-500 mr-2">*</i> */}
              Remarks:
            </div>
            <div className="col-span-6">
              <Textarea
                name="remarks"
                placeholder="Enter remarks"
                value={branchProfileData.remarks}
                onChange={handleOnChange}
              />
            </div>
            <div className="col-span-4"></div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="col-span-8 pt-4">
          <div className="grid grid-cols-8 gap-2">
            <div className="col-span-2"></div>
            <Button
              type="button"
              disabled={!changesMade}
              value={cancelButtonText}
              className="p-2 col-span-2"
              onClick={handleCancel}
            />
            <Button
              type="submit"
              disabled={!changesMade}
              value={submitButtonText}
              className="p-2 col-span-2"
              onClick={handleSubmit}
            />
            <div className="col-span-2"></div>
          </div>
        </div>
      </div>
    </ContentContainer>
  );  
};

export default BranchProfileForm;
